import { render, staticRenderFns } from "./TestReport.vue?vue&type=template&id=b87fd85e&scoped=true"
import script from "./TestReport.vue?vue&type=script&lang=js"
export * from "./TestReport.vue?vue&type=script&lang=js"
import style0 from "./TestReport.vue?vue&type=style&index=0&id=b87fd85e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87fd85e",
  null
  
)

export default component.exports